import React from "react";
import { Header } from "./Header";
import { MobileWarning } from "./MobileWarning";
import { Footer } from "./Footer";

export type FooterLogoType = "chimpers" | "ponke" | "catgame" | "mew" | "teddymoo" | "ripndip" | "bkfc" | "none";

interface LayoutProps {
  children: React.ReactNode;
  footerLogo?: FooterLogoType;
}

export function Layout({ children, footerLogo = "none" }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <MobileWarning />
      <Header />
      <main className="flex-1 flex flex-col">{children}</main>
      <Footer showLogo={footerLogo} />
    </div>
  );
}
